/* bf26y-fix.js (12 Oct 2026, builder pass). Display-only layer. Never touches ladder maths, the cart or checkout.
   r53 (15 Oct 2026): the ladder-line rewrite (1) and the "?" button + pop-out tip on every ladder bubble (2) are removed: the wording now lives only in
   bf26-core.js message() (one writer) and DESIGN.md 1.4 says rewrite the label instead of adding a "?". What is left:
   3) Thumbnails: lazy images in the builder tray and the cart drawer are made eager (they sit in sticky / off-screen panels where lazy loading can leave them blank).
   Rollback: git revert of the r53 drawer commit (older: remove the bf26y script line at the end of snippets/bf26z-sitewide.liquid). */
(function () {
  'use strict';
  if (window.__bf26y) return;
  window.__bf26y = 1;
  var D = document, raf = 0;

  function eager() {
    var imgs = D.querySelectorAll('.bbu-strip img[loading="lazy"], .bbu-th img[loading="lazy"], cart-drawer img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) imgs[i].setAttribute('loading', 'eager');
  }
  function run() { raf = 0; eager(); }
  function soon() { if (!raf) raf = setTimeout(run, 40); } /* setTimeout, not rAF: rAF never fires in a background or framed tab */
  try { new MutationObserver(soon).observe(D.documentElement, { childList: true, subtree: true }); } catch (e) {}
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', soon); else soon();
  window.addEventListener('load', soon);
})();
